// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"239":"d2344d94","488":"2fabe160","667":"b05e9c39","977":"18ef028f"}[chunkId] + ".chunk.js";
};